import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// Service
import { ApiService } from '../../shared/service/api.service';
import { GlobalService } from '../../shared/service/global.service';
@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styles: [
  ]
})
export class ArticleComponent implements OnInit {

  dataBanner;
  slugArticle;
  isLang;
  dataArticle = [];
  urlApi = null;
  btnLoad = true;
  textLoad = "Load More";

  constructor(private activedRoute: ActivatedRoute,
              private apiService: ApiService, 
              private globalService : GlobalService,
              private router: Router){
    this.globalService.isLoading.next(true);
  }

  ngOnInit(): void {
    // MultiLanguage
   this.isLang =  this.apiService.isLang();

    // Banner
    this.apiService.getDataApi('getSubHeaderByLink/news-and-events').subscribe(response => {
      if(response.success){
        this.dataBanner = response.data;
        // Meta
        this.globalService.updateMeta(
          response.data.title + ' | Prime Agri Resources',
          response.data.keyword,
          response.data.metadesc
        );
      }else{
        this.router.navigate(['/not-found']);
      }
    });

    // Content 
    this.apiService.getDataApi('getNewsRelease').subscribe(response => {
      this.getArticle(response.data);
      this.globalService.isLoading.next(false);
    });
  }

  getArticle(dataArtic){
    dataArtic.data.forEach(el => {
      this.dataArticle.push(el);
    });
    this.urlApi = dataArtic.next_page_url;
    if(this.urlApi === null){
      this.btnLoad = false;
    }
  }

  getMore(){
    this.textLoad = 'Loading...';
    if(this.urlApi) {
      this.apiService.getNextPage(this.urlApi).subscribe(response => {
        this.getArticle(response.data);
        this.textLoad = 'Load More';
      });
    }
  }
}
